import { postForm } from '@/utils/request'

// 验证订单 locator 码
const VERIFY_LOCATOR = '/order/border/locatorVerify'
// 验证交餐码并完成订单
const COMPLETE_ORDER = '/order/border/locatorOrderComplete'

/**
 * 验证订单 locator 码
 * @param {string} locator - 8位数字的 locator 码
 * @returns {Promise} 返回验证结果
 * @property {number} code - 状态码：1 验证成功到下一步，2 跳到已完单, 3 异常toast
 * @property {string} msg - 提示信息
 * @property {object} data - 返回数据
 * @property {string} data.orderId - 订单ID
 */
export const verifyLocator = params => {
  return postForm(VERIFY_LOCATOR, params)
}

/**
 * 验证交餐码并完成订单
 * @param {object} params - 参数对象
 * @param {string} params.orderId - 订单ID
 * @param {string} params.deliveryCode - 4位数字的交餐码
 * @param {string} params.locator - 8位数字的 locator 码
 * @returns {Promise} 返回验证结果
 * @property {number} code - 状态码：1 完单成功，3 异常toast
 * @property {string} msg - 提示信息
 */
export const completeOrder = params => {
  return postForm(COMPLETE_ORDER, params)
}